import React, { useCallback, useContext, useEffect, useState } from 'react'
import NavigationBarLayout from '../layouts/NavigationBarLayout'
import PageHeader from '../components/UI/PageHeader'
import Table from '../components/Table'
import Button from '../components/UI/Button'
import ChatView from '../components/Chats/ChatView'
import { AppContext } from '../contexts/AppContext'
import SelectDropDown from '../components/UI/SelectDropDown'
import { convertFirestoreTimeStampToDateObject } from '../Config'

const tableTitles = ["Date", "Name", "Email", "Phone", "Status"]

const StatusCard = ({ status }) => {
    let backgroundColor = '#815ECC', color = '#fff';
    if (status === 1) {
        backgroundColor = '#D7D7D7';
        color = '#000';
    } else if (status === 2) {
        backgroundColor = '#66BC73';
        color = '#fff';
    }

    return (
        <div style={{
            width: '100%', padding: '10px 20px', backgroundColor, color, fontSize: '14px', borderRadius: '7px',
            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'
        }}>
            {status === 0 && "New"}
            {status === 1 && "Read"} {/* placeholder not used for now */}
            {status === 2 && "Complete"}
        </div>
    )
}

const ChatsPage = props => {

    const [chatViewJsonDataIdx, setChatViewJsonDataIdx] = useState(null);
    const [loading, setLoading] = useState(true);
    const { backendApiCall, currentAgentUID, agentServerData, setCurrentAgentUID } = useContext(AppContext);
    const [pagination, setPagination] = useState();
    const [serverData, setServerData] = useState([]);
    const [tableRows, setTableRows] = useState();

    const fetchStatData = useCallback(async (pag) => {
        setLoading(true);
        try {
            const resp = await backendApiCall(`/dashboard/get-chat-history`, {
                pagination: pag,
                agentUID: currentAgentUID
            })
            const respJson = await resp.json();
            console.log("get-chat-history - res: ", respJson)

            if (!resp.ok)
                throw Error("server error")
            setServerData(prev => [...prev, ...respJson.chatCollections])
            setPagination(respJson.moreItemExists ? respJson.lastItem : null)
        } catch (e) {
            setServerData(null)
            setPagination(null)
            console.log("get-chat-history - error: ", e)
        }
        setLoading(false);
    }, [backendApiCall, currentAgentUID])

    useEffect(() => {
        if (pagination === undefined && currentAgentUID)
            fetchStatData()
    }, [fetchStatData, pagination, currentAgentUID])

    useEffect(() => {
        if (currentAgentUID) {
            setPagination(undefined)
            setServerData([])
        }
    }, [currentAgentUID])

    useEffect(() => {
        setTableRows(serverData ? serverData.map(r => {
            const convertedTimeStamp = convertFirestoreTimeStampToDateObject(r.timeStamp);
            const dateString = convertedTimeStamp
                ? convertedTimeStamp.toLocaleDateString() + " " + convertedTimeStamp.toLocaleTimeString()
                : "-"
            return [
                dateString,
                r?.collectedData?.capturedName || "-",
                r?.collectedData?.capturedEmail || "-",
                r?.collectedData?.capturedPhone || "-",
                <StatusCard status={r?.admin?.status || 0} />
            ]
        }) : null)
    }, [serverData])

    const updateMarkComplete = async (chatUID) => {
        try {
            const resp = await backendApiCall(`/dashboard/update-chat-collection`, {
                chatUID,
                action: "toggle-mark-complete"
            })
            const respJson = await resp.json();
            console.log("update-chat-collection - res: ", respJson)

            if (!resp.ok)
                throw Error("server error")
            setServerData(prev => prev.map(r => {
                if (r.chatUID !== chatUID)
                    return r
                else
                    return { ...r, ...respJson }
            }))
        } catch (e) {
            console.log("update-chat-collection - error: ", e)
        }
    }

    return (
        <NavigationBarLayout activeSegment="chats">

            <PageHeader title="Chats" />

            <div style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', marginBottom: '20px' }}>
                {agentServerData?.agentInfo?.availableAgents?.length > 1 && <SelectDropDown options={agentServerData.agentInfo.availableAgents.map(agentUID => {
                    return {
                        label: agentUID, key: agentUID
                    }
                })} currentOptionKey={currentAgentUID} onChange={(k) => { setCurrentAgentUID(k) }} wrapperStyles={{ minWidth: '250px' }} />}
            </div>

            <Table tableTitles={tableTitles} rows={tableRows}
                onClick={(idx) => chatViewJsonDataIdx ? null : setChatViewJsonDataIdx(idx + 1)} />

            {pagination && <Button text="Load more" wrapperStyles={{ margin: '15px auto 0px auto', padding: '15px 20px' }} isLoading={loading} onClick={() => fetchStatData(pagination)} />}

            {chatViewJsonDataIdx && <ChatView data={serverData[chatViewJsonDataIdx - 1]} onClose={() => setChatViewJsonDataIdx(null)} onMarkComplete={updateMarkComplete} />}

        </NavigationBarLayout >
    )
}

export default ChatsPage;